import { useMemo } from 'react';
export const useBannerItems = ({ banners, domain, autoPlay }) => {
    return useMemo(() => {
        return banners.map(banner => {
            const domainImages = banner.images[domain];
            return {
                id: `${domain}-${banner.id}`,
                image: domainImages.png,
                imageFit: banner.imageFit,
                webpImage: domainImages.webp,
                productAlias: banner.productAlias,
                onClick: banner.onClick,
            };
        });
    }, [banners, domain, autoPlay]);
};
